import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getUid } from "../../redux/authSlice";
import { Button } from "../../components";
import { getData } from "../../utils/firebase";
import DealershipInformation from "./dealership-information";
import Snackbar from "../../components/snackbar/snackbar";
// import { validateMobileNumber } from "../../utils/utils.service";
import { dealershipNameSet } from "../../redux/userSlice";

import UseBlockerHandler from "../../components/useBlocker";
import SkeletonDealershipSetting from "../../components/skeletons/dealership-setting";
import { put } from "../../api/setting/actions";
import { useNavigate } from "react-router";
import { East } from "@mui/icons-material";
import { useSettingsReadOnly } from "../../contexts/SettingsReadOnlyContext";

export default function Dealership() {
  const dispatch = useDispatch();
  const [dealerShip, setDealership]: any = useState();
  const uid = useSelector(getUid);
  const [notify, setNotify] = useState({ message: "", open: false, type: "" });
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const [dealerShipDefaultValues, setDealerShipDefaultValues] = useState({});
  const [blockChecker, setBlockChecker] = useState(false);

  const readOnly = useSettingsReadOnly();
  const navigate = useNavigate();

  const handleGetData = (data: any) => {
    const { dealerName, dealerEmail, dealerPhone, dealerAddress, website_link, usefulLinks } = data;
    setDealership({
      dealerName,
      dealerEmail,
      dealerPhone: dealerPhone.startsWith("+1")
        ? dealerPhone
        : "+1" + dealerPhone.replace(/\D/g, ""),
      dealerAddress,
      website: usefulLinks.website_link,
      inventoryLink: usefulLinks.inventory_link,
      financeLink: usefulLinks.finance_link,
      googleLink: usefulLinks.google_review_link,
      yelpLink: usefulLinks.yelp_review_link,
    });

    setDealerShipDefaultValues({
      dealerName,
      dealerEmail,
      dealerPhone,
      dealerAddress,
      website: website_link,
    });
  };

  const getAllData = useCallback(() => {
    getData(`dealers/${uid}/info`).then((r: any) => handleGetData(r));
    setBlockChecker(false);
  }, [uid]);

  useEffect(() => {
    getAllData();
  }, [getAllData]);

  const postDealershipInfo = async () => {
    const phone = dealerShip.dealerPhone.startsWith("+1")
      ? dealerShip.dealerPhone.slice(2)
      : dealerShip.dealerPhone;

    const data = {
      dealerAddress: dealerShip.dealerAddress,
      dealerEmail: dealerShip.dealerEmail,
      dealerPhone: `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`,
      dealerName: dealerShip.dealerName,
      website_link: dealerShip.website,
      ...(dealerShip.yelpLink && { yelp_review_link: dealerShip.yelpLink }),
      ...(dealerShip.googleLink && { google_review_link: dealerShip.googleLink }),
      ...(dealerShip.inventoryLink && { inventory_link: dealerShip.inventoryLink }),
      ...(dealerShip.financeLink && { finance_link: dealerShip.financeLink }),
    };

    console.log(data);

    try {
      await put(data, "/salesAgent-settingsApi/user_info/");
    } catch (error) {
      console.log(error);
    }
  };

  const postData = () => {
    if (!dealerShip.dealerName || !dealerShip.dealerPhone || !dealerShip.dealerAddress) return;
    setSubmitLoading(true);
    postDealershipInfo()
      .then(() => {
        setNotify({ message: "success", open: true, type: "" });
        dispatch(dealershipNameSet(dealerShip.dealerName));
      })
      .catch((err) => {
        setNotify({ message: err.message || "error", open: true, type: "error" });
      })
      .finally(() => {
        setSubmitLoading(false);
        getAllData();
      });
  };

  if (!dealerShip) return <SkeletonDealershipSetting />;
  return (
    <>
      {dealerShip && (
        <DealershipInformation
          state={dealerShip}
          setState={setDealership}
          dealerShipDefaultValues={dealerShipDefaultValues}
          oBlockChecker={setBlockChecker}
        />
      )}
      {dealerShip && !readOnly && (
        <Box
          display={"flex"}
          justifyContent={"flex-end"}
          width={"100%"}
          gap={1}
          mb={1}
          sx={{ marginTop: "16px" }}
        >
          <Button onClick={() => getAllData()} variant="outlined" color="primary">
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={postData} disabled={readOnly}>
            {submitLoading ? <CircularProgress color="info" size={16} /> : "Save Changes"}
          </Button>
        </Box>
      )}

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "16px",
          alignItems: "center",
          padding: "12px",
          borderRadius: "8px",
          backgroundColor: "#b1b1b10d",
          alignSelf: "center",
          marginTop: "32px",
        }}
      >
        <Typography sx={{ fontSize: "14px", fontWeight: "400" }}>
          Notifications preferences has been moved to the user management section.
        </Typography>
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={() => navigate("/setting/user-management")}
          startIcon={<East sx={{ width: "14px" }} />}
        >
          Go to User Management
        </Button>
      </Box>

      <Snackbar
        handleClose={() => setNotify({ message: "", open: false, type: "" })}
        message={notify.message}
        open={notify.open}
        type={notify.type}
      />
      <UseBlockerHandler status={blockChecker} />
    </>
  );
}
